export default __webpack_public_path__ + "static/media/18.1c43c4cb.jpg";